<template>
  <div v-bind="$attrs" v-resize="recalcWidthHeight" class="box-container ma-0 pa-0" :style="'height: ' + he + '; width: ' + wi + ';'">
    <div v-if="slotHeight" class="row-header ma-0 pa-0 my-2" :style="'width: 100%; height: ' + slotHeight + 'px !important;'">
      <slot name="top"> </slot>
    </div>
    <div v-if="showFilters" class="row-header ma-0 pa-0 mb-1" :style="'width: 100%; height: ' + filtersHeight + 'px !important;'">
      <v-text-field class="subtitle-2" align-items="center" outlined :label="s_SearchSort" v-model="filterText" hide-details dense @input="filterChanged" @keyup.enter="filterChanged">
        <template slot="append-outer">
          <v-menu transition="scroll-y-transition">
            <template v-slot:activator="{ on: onMenu }">
              <v-tooltip :disabled="hideTooltips" right>
                <template v-slot:activator="{ on: onTooltip }">
                  <v-icon v-on="{ ...onMenu, ...onTooltip }">mdi-sort</v-icon>
                </template>
                {{ s_DeviceList_Sort + ": " + devsSortType }}
              </v-tooltip>
            </template>

            <v-list class="ma-0 pa-0">
              <v-list-item v-for="item in devsSortTypes" :key="item.id" style="cursor: pointer" :style="item.name == devsSortType ? 'background-color: ' + Colors.MenuColor : ''">
                <v-list-item-title class="ma-0 pa-0 caption" @click="devsSortType = item.name">{{ item.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-text-field>
    </div>
    <!-- <div v-if="showFilters" class="row-header ma-0 pa-0 mb-1" :style="'width: 100%; height: ' + 1 + 'px'">
      <t-divider class="ma-0 mb-2 pa-0"></t-divider>
    </div> -->

    <div v-if="showAll" class="row-header ma-0 pa-0" :style="'width: 100%; height: ' + btnsHeight + 'px !important;'">
      <v-tooltip :disabled="hideTooltips" right>
        <template v-slot:activator="{ on }">
          <v-card v-on="on" class="ma-0 pa-0" width="100%" outlined :rounded="false" :height="btnsHeight - 2" @click="itemClick(undefined)" :style="!lastItem ? 'background: ' + (isInDarkMode ? Colors.ActiveItemBackground : Colors.MenuColor) : ''">
            <v-row class="ma-0 mx-3 pa-0" justify="start" align="center" style="width: 500px; height: 100%">
              <!-- <v-btn class="ma-0 pa-0" text style="pointer-events: none; width: 100%"> -->
              <!-- <v-icon class="mx-2" small v-if="item.Status" :color="item.Status.Color">{{ item.Status.Icon }}</v-icon> -->
              <span class="subtitle-2">{{ s_AllDevices }}</span>
              <!-- </v-btn> -->
            </v-row>
          </v-card>
        </template>
        {{ s_DeviceList_ChooseAllDevs }}
      </v-tooltip>
    </div>
    <div class="row-content ma-0 pa-0" ref="refDeviceListContainer">
      <div style="visibility: hidden; height: 1px; width: 1px"></div>
      <v-virtual-scroll
        v-if="getDevices && getDevices.length > 0"
        ref="refVirtualScroller"
        :style="'left: 0; right: 0; bottom: 0; top: auto;'"
        :items="getDevices"
        :item-height="btnsHeight"
        :height="virtualScrollerHeight"
        :width="wi"
        style="overflow-x: hidden"
      >
        <template v-slot="{ item }">
          <v-tooltip :disabled="hideTooltips" :open-on-click="false" right>
            <template v-slot:activator="{ on }">
              <v-card v-on="on" class="ma-0 pa-0" width="100%" outlined :rounded="false" :height="btnsHeight - 2" @click="itemClick(item)" :style="lastItem == item ? 'background: ' + (isInDarkMode ? Colors.ActiveItemBackground : Colors.MenuColor) : ''">
                <v-row class="ma-0 pa-0" justify="start" align="center" style="width: 500px; height: 100%">
                  <!-- <v-btn class="ma-0 pa-0" text style="pointer-events: none; width: 100%"> -->
                  <v-icon class="mx-2" small v-if="item.Status" :color="item.Status.Color">{{ item.Status.Icon }}</v-icon>
                  <span class="caption">{{ item.Name }}</span>
                  <!-- </v-btn> -->
                </v-row>
              </v-card>
            </template>
            {{ item.sn + ", " + item.model.name + ", " + item.Address }}
          </v-tooltip>
        </template>
      </v-virtual-scroll>
      <v-card v-else class="ma-0 pa-0" align="center" justify="center" width="100%" :height="virtualScrollerHeight - 4" outlined :rounded="false">
        <div class="subtitle-2" :style="'width: 100%; height: 100%'">{{ s_DeviceList_NoDevsFound }}</div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { TR } from "../../main";
export default {
  props: {
    value: {
      default: null,
    },
    showAll: {
      type: Boolean,
      default: false,
    },
    showFilters: {
      type: Boolean,
      default: true,
    },
    devices: {
      type: Array,
      default: () => [],
    },
    width: {
      type: [Number, String],
      default: 150,
    },
    height: {
      type: [Number, String],
      default: "100%",
    },
    buttonsHeight: {
      type: Number,
      default: 40,
    },
    slotHeight: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      listHeight: false,
      btnsHeight: this.buttonsHeight,
      filtersHeight: 40,
      virtualScrollerHeight: 500,
      lastItem: null,
      filterText: "",
      devsSortTypes: [
        { id: 0, name: TR.DeviceList_NameAsc, prop: "Name", asc: true },
        { id: 1, name: TR.DeviceList_NameDesc, prop: "Name" },
        { id: 2, name: TR.DeviceList_AddressAsc, prop: "Address", asc: true },
        { id: 3, name: TR.DeviceList_AddressDesc, prop: "Address" },
        { id: 4, name: TR.DeviceList_SnAsc, prop: "sn", asc: true },
        { id: 5, name: TR.DeviceList_SnDesc, prop: "sn" },
      ],
      devsSortType: TR.DeviceList_NameAsc,

      recalcTimeout: null,
      manualClick: true,
      s_SearchSort: TR.SearchSort,
      s_DeviceList_Sort: TR.DeviceList_Sort,
      s_AllDevices: TR.AllDevices,
      s_DeviceList_ChooseAllDevs: TR.DeviceList_ChooseAllDevs,
      s_DeviceList_NoDevsFound: TR.DeviceList_NoDevsFound,
    };
  },
  methods: {
    filterChanged() {
      this.$emit("filterChanged", this.filterText ? undefined : this.getDevices);
    },
    datesChanged() {
      this.$emit("datesChanged", this.datesFromTo);
    },
    itemClick(item) {
      if (item != this.lastItem) {
        this.manualClick = false;
        this.lastItem = item;
        this.$emit("click", item);
        this.$emit("input", item);
      }
    },
    recalcWidthHeight() {
      if (this.recalcTimeout) clearTimeout(this.recalcTimeout);
      this.recalcTimeout = setTimeout(() => {
        if (this.$refs.refDeviceListContainer && this.$refs.refDeviceListContainer.clientHeight > 0) {
          this.virtualScrollerHeight = this.$refs.refDeviceListContainer.clientHeight - 5;
        }
      }, 333);
    },
  },
  computed: {
    wi() {
      return this.width instanceof String || typeof this.width === "string" ? this.width : this.width + "px";
    },
    he() {
      return this.height instanceof String || typeof this.height === "string" ? this.height : this.height + "px";
    },
    getDevices() {
      // var filterIdx = this.devsFilterTypes.findIndex(f => f.name == this.devsFilterType);
      var sort = this.devsSortTypes.find((st) => st.name == this.devsSortType);
      var prop = sort.prop;
      var data = this.devices.filter((i) => !this.filterText || i.Name.toLowerCase().contains(this.filterText.toLowerCase()) || i.Address.toLowerCase().contains(this.filterText.toLowerCase()) || i.sn.toLowerCase().contains(this.filterText.toLowerCase()));
      return sort.asc ? data.sort((a, b) => a[prop].localeCompare(b[prop], "bg", { sensitivity: "base" })) : data.sort((a, b) => b[prop].localeCompare(a[prop], "bg", { sensitivity: "base" }));
    },
  },
  watch: {
    slotHeight: {
      handler() {
        this.recalcWidthHeight();
      },
    },
    value: {
      handler() {
        this.lastItem = this.value;
        if (this.manualClick && this.$refs.refVirtualScroller) {
          var scrlPos = this.getDevices.indexOf(this.lastItem) * this.buttonsHeight;
          //   if (scrlPos > this.$refs.refVirtualScroller.$el.scrollTop) {
          //     var fn = setInterval(() => {
          //       if (scrlPos > this.$refs.refVirtualScroller.$el.scrollTop) {
          //         this.$refs.refVirtualScroller.$el.scrollTop += 100;
          //       } else {
          //         this.$refs.refVirtualScroller.$el.scrollTop = scrlPos;
          //         clearInterval(fn);
          //       }
          //     }, 1);
          //   } else if (scrlPos < this.$refs.refVirtualScroller.$el.scrollTop) {
          //     var fn2 = setInterval(() => {
          //       if (scrlPos < this.$refs.refVirtualScroller.$el.scrollTop) {
          //         this.$refs.refVirtualScroller.$el.scrollTop -= 100;
          //       } else {
          //         this.$refs.refVirtualScroller.$el.scrollTop = scrlPos;
          //         clearInterval(fn2);
          //       }
          //     }, 1);
          //   }
          this.$refs.refVirtualScroller.$el.scrollTop = scrlPos;
        }
        this.manualClick = true;
      },
      deep: true,
    },
    // lastItem: {
    //   handler() {
    //   },
    //   deep: true,
    // },
  },
  mounted() {
    this.$nextTick(() => {
      this.recalcWidthHeight();
    });
  },
};
</script>

<style>
</style>